
































































































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Title from '../../components/Title.vue';
import { Message } from 'element-ui';
import { State, 
  ConfigListParams,
  GeneralUserListRes,
  GeneralUserListData,
  TemplateTypeEnumsData,
  NewReportParams,
  GenerateData,
  DataNoCase,
  ConfigListData,
  StoreGroupListData,
  TemplateTypeEnumsRes,
  ConfigListTable,
  KeyValue,
  Users,
  StoreGroup,
  Stores,
} from '@/store/pages/config/index.d';
import {
  StoreListRes,
  StoreListData,
  StoreListTable,
  StoreGroupParams,
  StoreGroupRes,
  StoreGroupTable,
  StoreGroupData,
} from '@/store/pages/manage/index.d';
const Config = namespace('config');
const Manage = namespace('manage');

@Component({
  components: {
    Title,
  },
})
export default class Index extends Vue {
  private title = ['报表配置'];
  @Config.Getter('templateTypeEnums') private templateTypeEnums!: TemplateTypeEnumsData;
  @Config.Getter('generalUserList') private generalUserList!: GeneralUserListData[];
  @Manage.Getter('storeGroup') private storeGroup!: StoreGroupData;
  @Config.Getter('storeGroupList') private storeGroupList!: StoreGroupListData[];
  @Manage.Getter('storeList') private storeList!: StoreListData;
  @Config.Getter('configList') private configList!: ConfigListData;

  @Config.Action('getTemplateTypeEnums') private getTemplateTypeEnums: any;
  @Config.Action('getGeneralUserList') private getGeneralUserList: any;
  @Config.Action('saveNewReport') private saveNewReport: any;
  @Config.Action('editReport') private editReport: any;
  @Manage.Action('getStoreGroup') private getStoreGroup: any;
  @Config.Action('getStoreGroupList') private getStoreGroupList: any;
  @Manage.Action('getStoreList') private getStoreList: any;
  @Config.Action('getConfigList') private getConfigList: any;

  private checked: boolean = false;
  private disabled: boolean = true;
  private input: string = '08:30';
  private messagePushArr: string[] = [];

  private data1: DataNoCase[] = [];
  private selectedValue: number[] = [];
  private allData: GenerateData[] = [];
  private selectedData: number[] = [];
  private storeTransfer: boolean = true;
  private showName: boolean = false;
  private dialogTableVisible: boolean = false;
  private range: number = 1;
  private updateName: string = '';
  private temporary: number = 0;
  private report_id: number = 0;
  private reportStatus: string[] = ['启用', '禁用'];
  private transferTitle: string[][] = [
    ['所有门店组', '已选门店组'],
    ['所有门店', '已选门店'],
  ];
  private newReport: NewReportParams = {
    name: '', 
    template: 0, 
    report_type: 1,
    statistic_range: 1, 
    stores: [], 
    store_groups: [], 
    users: [], 
    status: 1,
  };
  private requestParams: ConfigListParams = {
    page: 0,
    count: 10,
    sort_order: 1,
  };

  public mounted() {
    this.initMessagePushArr();
    if (this.$route.query.report_id) {
      this.report_id = ~~this.$route.query.report_id;
      this.title.push('编辑报表');
    } else {
      this.title.push('新建报表');
    }
    this.getStoreList(this.requestParams);
    this.getStoreGroupList().then((res: StoreGroupRes) => {
      this.generatestoreGroupData();
    });
    
    this.getTemplateTypeEnums().then((res: TemplateTypeEnumsRes) => {
      this.getDefaultInfo();
    });
    
    this.getGeneralUserList().then((res: GeneralUserListRes) => {
      this.generateUserData();
    });
  }
  public initMessagePushArr() {
    for (let i = 7; i < 23; i++) {
      this.messagePushArr.push(`${this.toTen(i)}:00`);
      this.messagePushArr.push(`${this.toTen(i)}:30`);
    }
    this.messagePushArr.push('23:00');
  }
  public toTen(num: number) {
    return num < 10 ? '0' + num : num;
  }
  public getDefaultInfo() {
    if (Object.keys(this.$route.query).length) {
      this.configList.table.forEach((item: ConfigListTable) => {
        if (item.report_id === this.report_id) {
          this.templateTypeEnums.report_type.forEach((type: KeyValue) => {
            if (type.value === item.report_type) {
              this.newReport.report_type = type.key;
            }
          })
          this.templateTypeEnums.templates.forEach((temp: KeyValue) => {
            if (temp.value === item.template) {
              this.newReport.template = temp.key;
            }
          })
          this.newReport.status = item.status;
          this.newReport.name = item.name;
          this.range = item.statistic_range;
          this.newReport.statistic_range = item.statistic_range;
          this.input = item.pushing_time || '08: 30';
          this.checked = item.is_pushing !== 2;
          this.disabled = item.is_pushing === 2;
          if (item.statistic_range === 1) {
            this.data1 = [];
            this.getStoreGroupList().then((res: StoreGroupRes) => {
              this.generatestoreGroupData();
            });
            item.store_groups.forEach((group: StoreGroup) => {
              this.selectedValue.push(group.store_group_id);
              this.newReport.store_groups.push(group.store_group_id);
            })
          } else {
            this.data1 = [];
            this.getStoreList(this.requestParams).then((res: StoreListRes) => {
              this.generatestoreData();
            });
            item.stores.forEach((store: Stores) => {
              this.selectedValue.push(store.store_id)
              this.newReport.stores.push(store.store_id);
            })
          }
          item.users.forEach((user: Users) => {
            this.selectedData.push(user.user_id);
          })
        }
      })
    }
  }
  public checkboxChange() {
    this.disabled = !this.checked;
  }
  public changeType(key: number) {
    this.newReport.report_type = key;
  }
  public changeTemplate(key: number) {
    this.newReport.template = key;
  }
  public changeStatus(id: number) {
    this.newReport.status = id + 1;
  }
  public filterMethod1(query: string, item: GenerateData) {
    
    return item.name.indexOf(query) > -1;
  }
  public filterMethod2(query: string, item: GenerateData) {
    return item.name.indexOf(query) > -1 || item.mobile_number.indexOf(query) > -1 || item.belong_store.indexOf(query) > -1 || item.lowercaseName.indexOf(query) > -1;
  }
  public clickStoreGroup() {
    if (this.selectedValue.length) {
      this.dialogTableVisible = true;
      this.updateName = 'storeGroup';
    } else {
      this.generatestoreGroupData();
      this.range = this.temporary;
      this.newReport.statistic_range = this.temporary;
    }
  }
  public clickStore() {
    if (this.selectedValue.length) {
      this.dialogTableVisible = true;
      this.updateName = 'store';
    } else {
      this.generatestoreData();
      this.range = this.temporary;
      this.newReport.statistic_range = this.temporary;
    }
  }
  public generatestoreGroupData() {
    this.temporary = 1;
    this.storeTransfer = true;
    this.data1 = [];
    this.storeGroupList.forEach((item: StoreGroupListData, index: number, arr: StoreGroupListData[]) => {
      let json: DataNoCase = {
        label: item.name,
        key: item.store_group_id,
        name: item.name,
      }
      this.data1.push(json);
    })
  }
  public generatestoreData() {
    this.temporary = 2;
    this.storeTransfer = true;
    this.data1 = [];
    this.storeList.table.forEach((item: StoreListTable, index: number, arr: StoreListTable[]) => {
      let json: DataNoCase = {
        label: item.name,
        key: item.store_id,
        name: item.name,
      }
      this.data1.push(json);
    })
  }
  public generateUserData() {
    this.generalUserList.forEach((item: GeneralUserListData, index: number, arr: GeneralUserListData[]) => {
      let json: GenerateData = {
        label: `${item.name}\xa0\xa0\xa0\xa0\xa0${item.mobile_number}\xa0\xa0\xa0\xa0\xa0${item.belong_store}`,
        key: item.user_id,
        name: item.name,
        mobile_number: item.mobile_number,
        belong_store: item.belong_store,
        lowercaseName: item.name.toLocaleLowerCase(),
      }
      this.allData.push(json);
    })
  }
  public exchangeConfirm() {
    this.dialogTableVisible = false;
    this.selectedValue = [];
    if (this.updateName === 'store') {
      this.generatestoreData();
      this.range = this.temporary;
      this.newReport.statistic_range = this.temporary;
    } else {
      this.generatestoreGroupData();
      this.range = this.temporary;
      this.newReport.statistic_range = this.temporary;
    }
  }
  public go(path: string) {
    this.$router.push({path});
  }
  public handleSelect(key: number, keyPath: string) {
    // console.log(key, keyPath)
  }
  public save() {
    if (this.range === 2) {
      this.newReport.stores = this.selectedValue;
    } else {
      this.newReport.store_groups = this.selectedValue;
    }
    this.newReport.users = this.selectedData;
    const repeat = this.configList.table.some((item) => {
      return item.name === this.newReport.name;
    })
    const messagePush: {is_pushing: number, pushing_time: string} = {
      is_pushing: this.checked === true ? 1 : 2,
      pushing_time: this.input,
    }
    if (this.newReport.template === 0) {
      Message.error('未选择统计模板');
    } else if (this.newReport.name === '') {
      Message.error('报表名称不能为空');
    } else if (this.selectedValue.length === 0) {
      Message.error('未选择门店或者门店组');
    } else if (this.selectedData.length === 0) {
      Message.error('未设置查看人');
    } else if (this.report_id) {
      if (this.newReport.template === 6) {
        this.editReport(Object.assign({}, {reportId: this.report_id}, this.newReport, messagePush));
      } else {
        this.editReport(Object.assign({}, {reportId: this.report_id}, this.newReport));
      }
      this.$router.go(-1);
    } else if (repeat) {
      Message.error('报表名称已存在');
    } else {
      if (this.newReport.template === 6) {
        this.saveNewReport(Object.assign({}, this.newReport, messagePush));
      } else {
        this.saveNewReport(this.newReport);
      }
      this.$router.push({
        path: '/index/reportConfig/config'
      });
    }
  }
  public modifyName() {
    this.$nextTick(() => {
      if (this.newReport.name.length > 15) {
        this.showName = true;
        this.newReport.name = this.newReport.name.substr(0, 15);
      } else {
        this.showName = false;
      }
    })
  }
  public handlePick(command: any) {
    this.input = command;
  }
}
